import { render, staticRenderFns } from "./NavbarDestinationsPhone.vue?vue&type=template&id=06f1d0e5&scoped=true&"
import script from "./NavbarDestinationsPhone.vue?vue&type=script&lang=js&"
export * from "./NavbarDestinationsPhone.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDestinationsPhone.vue?vue&type=style&index=0&id=06f1d0e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1d0e5",
  null
  
)

export default component.exports